import {
   ChangeDetectionStrategy,
   Component,
   Inject,
   OnDestroy,
   OnInit,
   ViewChild,
   ViewEncapsulation,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { DeviceTypes } from 'generated/graphql-types';
import { Observable, Subject } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { DeviceDetailFormService } from '../../device-details/services/device-detail-form.service';
import { AddDeviceData } from '../models/add-device-data';
import { createDevice, createDeviceAndAddAnother } from '../state/add-device.actions';
import { getAddDeviceCallState } from '../state/add-device.selectors';
import { AddDeviceViewComponent } from '../views/add-device-view.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [DeviceDetailFormService],
    selector: 'ndt-add-device',
    styleUrls: ['./add-device.component.scss'],
    templateUrl: './add-device.component.html',
    standalone: false
})
export class AddDeviceComponent implements OnInit, OnDestroy, FormComponent {
   @ViewChild(AddDeviceViewComponent) AddDeviceViewComponent: AddDeviceViewComponent;

   callState: Observable<CallState>;

   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   constructor(
      protected store: Store,
      protected formService: DeviceDetailFormService,
      protected router: Router,
      @Inject(MAT_DIALOG_DATA) public data: AddDeviceData,
      private dialogService: LcsDialogService
   ) {
      this.callState = this.store.pipe(select(getAddDeviceCallState));
   }

   ngOnInit(): void {
      this.form = this.formService.form;
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.store.dispatch(
            createDevice({
               device: this.formService.getValue(null),
            })
         );
      }
   }

   onCreateAndAddAnother(): void {
      if (this.form.valid) {
         this.store.dispatch(
            createDeviceAndAddAnother({
               device: this.formService.getValue(null),
               accountName: this.form.get('account')?.value?.name ?? null,
            })
         );
      }
   }

   deviceDisplayWith(option: DeviceTypes): string {
      return `${option ?? ''}`;
   }
}
